import { Box, Pagination, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { PageSize } from "lib/@components/pagination/page-size"

export function DataTablePagination({ skip, take, total, page, setTake, setPage, itemLabel = "results" }) {
    const from = total === 0 ? 0 : skip + 1
    const to = Math.min(skip + take, total)
    const pageCount = Math.max(1, Math.ceil(total / take))

    return (
        <ListItemBox sx={{ py: 1 }} data-cy="data-table-pagination">
            <Typography variant="body2" color="text.primary" data-cy="data-table-count">
                Showing {from}–{to} of{" "}
                <Box component="span" sx={{ fontWeight: 600 }}>
                    {total}
                </Box>{" "}
                {itemLabel}
            </Typography>
            <Box flex={1} />
            <PageSize take={take} setTake={setTake} />
            <Pagination size="small" color="primary" count={pageCount} page={page} onChange={handlePageChange} />
        </ListItemBox>
    )

    function handlePageChange(_event, value) {
        setPage(value)
    }
}
